import { render, staticRenderFns } from "./VBtnMenuItem.vue?vue&type=template&id=76191045&scoped=true&functional=true"
import script from "./VBtnMenuItem.vue?vue&type=script&lang=js"
export * from "./VBtnMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "76191045",
  null
  
)

export default component.exports